/// <amd-module name="Tfs/Frame/Components/Navigation/NavigationHeaderButton" />
import * as React from "react";
import { ProjectNavigationCallout } from "Tfs/Frame/Components/Navigation/ProjectNavigation";
import * as Resources from "Tfs/Frame/Resources";
import { useComponentContext, VssComponent } from "VSS/Platform/Layout";
import { ExpandableContainer, IExpandable } from "VSSUI/Expandable";
import { Icon, IconSize } from "VSSUI/Icon";
import { KeyCode } from "VSSUI/Util";
import { ScreenSizeConditional } from "VSSUI/Utilities/ScreenSize";
import { useFlyoutNavigation } from "../../Util/Navigation";

const NavigationHeaderButton = () => {
    const pageContext = useComponentContext().pageContext;

    const renderCallout = (expandable: IExpandable): JSX.Element => {
        return <ProjectNavigationCallout collapse={false} closeCallout={expandable.collapse} />;
    };

    return (
        <ScreenSizeConditional condition={(screenSize) => useFlyoutNavigation(pageContext, screenSize)}>
            <ExpandableContainer
                className="navigation-header-button commandbar-item commandbar-icon flex-noshrink justify-center cursor-pointer"
                renderCallout={renderCallout}
                tabIndex={0}
                expandKey={[KeyCode.enter, KeyCode.space]}
                ariaLabel={Resources.NavigationMenu}
            >
                <Icon iconName="GlobalNavButton" size={IconSize.medium} />
            </ExpandableContainer>
        </ScreenSizeConditional>
    );
};

VssComponent.register("ms.vss-tfs-web.frame.navigation-header-button", NavigationHeaderButton);
